<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-xl-8 col-lg-12">
          <div class="mb-5">
            <a-tabs defaultActiveKey="1">
              <a-tab-pane tab="Orders" key="1">
                <a-select defaultValue="lastDay" style="width: 120px">
                  <a-select-option value="lastDay">Last Day</a-select-option>
                  <a-select-option value="lastWeek">Last Week</a-select-option>
                  <a-select-option value="lastMonth">Last Month</a-select-option>
                  <a-select-option value="last3Month">Last 3 Month</a-select-option>
                </a-select>
                <vue-chartist
                  class="height-200 mt-4"
                  type="Line"
                  :data="ordersGraph"
                  :options="chartistOptions"
                />
                <div class="row">
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-16 mb-2">Revenue</div>
                      <div class="font-size-20 text-black">
                        <strong>{{ordersInfo.revenue}}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-16 mb-2">Tax</div>
                      <div class="font-size-20 text-black">
                        <strong>{{ordersInfo.tax}}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-16 mb-2">Shipping</div>
                      <div class="font-size-20 text-black">
                        <strong>{{ordersInfo.shipping}}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-16 mb-2">Quantity</div>
                      <div class="font-size-20 text-black">
                        <strong>{{ordersInfo.quantity}}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane tab="Amount" key="2">
                <a-select defaultValue="lastDay" style="width: 120px">
                  <a-select-option value="lastDay">Last Day</a-select-option>
                  <a-select-option value="lastWeek">Last Week</a-select-option>
                  <a-select-option value="lastMonth">Last Month</a-select-option>
                  <a-select-option value="last3Month">Last 3 Month</a-select-option>
                </a-select>
                <vue-chartist
                  class="height-200 mt-4"
                  type="Line"
                  :data="amountGraph"
                  :options="chartistOptions"
                />
                <div class="row">
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-16 mb-2">Revenue</div>
                      <div class="font-size-20 text-black">
                        <strong>{{amountInfo.revenue}}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-16 mb-2">Tax</div>
                      <div class="font-size-20 text-black">
                        <strong>{{amountInfo.tax}}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-16 mb-2">Shipping</div>
                      <div class="font-size-20 text-black">
                        <strong>{{amountInfo.shipping}}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-16 mb-2">Quantity</div>
                      <div class="font-size-20 text-black">
                        <strong>{{amountInfo.quantity}}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
          <div>
            <a-tabs defaultActiveKey="1">
              <a-tab-pane tab="Todos" key="1">
                <a-table
                  :columns="bestsellersColumns"
                  :dataSource="bestsellersData"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <a slot="product" slot-scope="text" href="javascript: void(0);">{{text}}</a>
                  <span slot="price" slot-scope="text">${{text}}</span>
                </a-table>
              </a-tab-pane>
              <a-tab-pane tab="Risco 1-2" key="2">
                <a-table
                  :columns="mostViewedColumns"
                  :dataSource="mostViewedData"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <a slot="product" slot-scope="text" href="javascript: void(0);">{{text}}</a>
                  <span slot="price" slot-scope="text">${{text}}</span>
                </a-table>
              </a-tab-pane>
              <a-tab-pane tab="Risco 3" key="3">
                <a-table
                  :columns="customersColumns"
                  :dataSource="newCustomersData"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <a slot="name" slot-scope="text" href="javascript: void(0);">{{text}}</a>
                  <span slot="total" slot-scope="text">${{text}}</span>
                </a-table>
              </a-tab-pane>
              <a-tab-pane tab="Risco 4" key="4">
                <a-table
                  :columns="customersColumns"
                  :dataSource="topCustomersData"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <span slot="total" slot-scope="text">${{text}}</span>
                </a-table>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
        <div class="col-xl-4 col-lg-12">
          <div class="row mb-5">
            <div class="col-xl-12 col-lg-6 col-sm-12">
              <cui-info-card form="stats-large" icon="download" type="primary"/>
            </div>
            <div class="col-xl-12 col-lg-6 col-sm-12">
              <cui-info-card form="stats-large" icon="stack" type="default"/>
            </div>
          </div>
            <!--  Task Table Begins         -->

           <div class="card">
          <div class="card-header">
            <div class="utils__title">
              <strong>Ações Recomendadas</strong>
            </div>
            <div class="utils__titleDescription">Block with important Task Table information</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <a-table
                  :columns="taskTableColumns"
                  :dataSource="taskTableData"
                  :pagination="false"
                  :rowSelection="rowSelection"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <a slot="name" slot-scope="text" href="javascript: void(0);">{{text}}</a>
                  <a slot="username" slot-scope="username" href="javascript: void(0);">{{username}}</a>
                  <a-dropdown slot="actions">
                    <a-button size="small">Actions
                      <a-icon type="down"/>
                    </a-button>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a href="javascript:;">1st menu item</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a href="javascript:;">2nd menu item</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a href="javascript:;">3rd menu item</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </a-table>
              </div>
            </div>
          </div>
        </div>
            <!--  Task Table End         -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ordersGraph,
  amountGraph,
  ordersInfo,
  amountInfo,
  bestsellersData,
  mostViewedData,
  newCustomersData,
  topCustomersData,
  lastOrdersData,
  lastSearchData,
  topSearchData,
  taskTableData,
} from './data.json'

import VueChartist from 'v-chartist'
import ChartistTooltip from 'chartist-plugin-tooltips-updated'
import CuiInfoCard from '@/components/CleanUIComponents/InfoCard'
const chartistOptions = {
  fullWidth: true,
  showArea: true,
  chartPadding: {
    right: 30,
    left: 0,
  },
  plugins: [
    ChartistTooltip({
      anchorToPoint: false,
      appendToBody: true,
      seriesName: false,
    }),
  ],
}

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows)
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows)
  },
}

const taskTableColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Username',
    dataIndex: 'username',
    key: 'username',
    scopedSlots: { customRender: 'username' },
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    scopedSlots: { customRender: 'actions' },
  },
]

const bestsellersColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: 'Nome',
    dataIndex: 'product',
    key: 'product',
    sorter: (a, b) => a.product - b.product,
    scopedSlots: { customRender: 'product' },
  },
  {
    title: 'Idade',
    dataIndex: 'price',
    key: 'price',
    sorter: (a, b) => a.price - b.price,
    scopedSlots: { customRender: 'price' },
  },
  {
    title: 'Gênero',
    dataIndex: 'orderquantity',
    key: 'orderquantity',
    sorter: (a, b) => a.orderquantity - b.orderquantity,
  },
  {
    title: 'Localização',
    dataIndex: 'orderquantity',
    key: 'orderquantity',
    sorter: (a, b) => a.orderquantity - b.orderquantity,
  },
  {
    title: 'Ind. Risco',
    dataIndex: 'orderquantity',
    key: 'orderquantity',
    sorter: (a, b) => a.orderquantity - b.orderquantity,
  },
  {
    title: 'Ind. Saúde',
    dataIndex: 'orderquantity',
    key: 'orderquantity',
    sorter: (a, b) => a.orderquantity - b.orderquantity,
  },
]

const mostViewedColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
    sorter: (a, b) => a.product - b.product,
    scopedSlots: { customRender: 'product' },
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    sorter: (a, b) => a.price - b.price,
    scopedSlots: { customRender: 'price' },
  },
  {
    title: 'Views',
    dataIndex: 'views',
    key: 'views',
    sorter: (a, b) => a.views - b.views,
  },
]

const customersColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name - b.name,
    scopedSlots: { customRender: 'name' },

  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    sorter: (a, b) => a.date - b.date,
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total',
    sorter: (a, b) => a.total - b.total,
    scopedSlots: { customRender: 'total' },
  },
]

const lastOrdersColumns = [
  {
    title: 'Customers',
    dataIndex: 'customer',
    key: 'customer',
  },
  {
    title: 'Items',
    dataIndex: 'items',
    key: 'items',
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total',
    scopedSlots: { customRender: 'total' },
  },
]

const searchColumns = [
  {
    title: 'Search Term',
    dataIndex: 'searchTerm',
    key: 'searchTerm',
  },
  {
    title: 'Results',
    dataIndex: 'result',
    key: 'result',
  },
  {
    title: 'Uses',
    dataIndex: 'uses',
    key: 'uses',
  },
]

export default {
  components: {
    'vue-chartist': VueChartist,
    CuiInfoCard,
  },
  data: function () {
    return {
      ordersGraph,
      amountGraph,
      rowSelection,
      ordersInfo,
      amountInfo,
      mostViewedData,
      newCustomersData,
      topCustomersData,
      lastOrdersData,
      lastSearchData,
      topSearchData,
      chartistOptions,
      bestsellersData,
      bestsellersColumns,
      customersColumns,
      mostViewedColumns,
      lastOrdersColumns,
      searchColumns,
      taskTableColumns,
      taskTableData,
    }
  },
}
</script>
